import { ReactNode } from 'react';

import { BasicInformation } from '../../../icons/basic';
import { Typography } from '../../typography/Typography';

type Props = {
  message: string | ReactNode;
};

export const FeedbackError = ({ message }: Props) => {
  return (
    <div className="flex items-start gap-2 bg-feedback-error p-4 text-feedback-error">
      <BasicInformation className="size-[1.125rem] shrink-0 text-feedback-error" />
      <Typography
        variant="label-small"
        type="span"
        // break-word tailwind class doesn't work correctly
        className="[word-break:break-word]"
      >
        {message}
      </Typography>
    </div>
  );
};
